<template>
  <div class="filters-section is-hidden">
    <div class="filters-container">
      <div class="filters__column filters__column--left">
        <div class="filters__question">
          <h1>Aujourd’hui<br>vous vous sentez ?</h1>
        </div>
      </div>

      <div class="filters__column filters__column--right">
        <div class="filters__choices">
          <div class="filters__choice" v-for="filter in filters" :class="{'filters__choice--active': currentFilter == filter.value }">
            <a href="#" @click.prevent="clickFilter(filter.value)">
              <span class="choice-inner">{{ filter.name | capitalize }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'styles/components/filters.styl'
import FILTER_TYPES from './classes/FilterTypes'
import Emitter from 'core/Emitter'

export default {
  name: 'filters',
  data () {
    return {
      filters: [],
      currentFilter: null
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString().toLowerCase()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  mounted () {
    for (let index in FILTER_TYPES) {
      let filter = {
        name: index,
        value: FILTER_TYPES[index]
      }
      this.filters.push(filter)
    }

    this.bindAll()
    this.addListeners()
  },

  beforeDestroy () {
    this.removeListeners()
  },

  methods: {
    bindAll () {
      ['resetFilter']
          .forEach((fn) => (this[fn] = this[fn].bind(this)))
    },

    addListeners () {
      Emitter.on('FILTERS:RESET', this.resetFilter)
    },

    removeListeners () {
      Emitter.removeListener('FILTERS:RESET', this.resetFilter)
    },

    resetFilter () {
      this.currentFilter = null
    },

    clickFilter (id) {
      this.currentFilter = id
      /**
       * TODO
       * penser à créer un btn d'interface pour reset le filtre
       */
      Emitter.emit('CLICK_FILTER', {
        filterId: id
      })
    }
  }
}
</script>



/** WEBPACK FOOTER **
 ** filters.vue?5aa99f60
 **/